import { useAppUsers } from '@gozoki/api'
import { includesLowerCase } from '@gozoki/tools'
import { createFileRoute } from '@tanstack/react-router'
import { useMemo, useState } from 'react'
import { useToast } from '~/components/communication/Toast'
import { AppUsersHeaderActions } from '~/components/routes/users/app-users-header-actions'
import { appUsersColumns } from '~/components/routes/users/users-columns'
import { UsersPageLayout, UsersSearchGrid } from '~/components/routes/users/users-page-layout'
import { useDeleteSelectedUsers } from '~/components/routes/users/use-delete-selected-users'
import { withRoutePermissions } from '~/utils/rbac'

export const Route = createFileRoute('/_authenticated/users/app')({
  staticData: {
    permission: ['read', 'users'],
  },
  component: AppUsersPage,
})
withRoutePermissions(Route)

function AppUsersPage() {
  const [Toast, showToast] = useToast()
  const [search, setSearch] = useState('')
  const [selected, setSelected] = useState<number[]>([])

  const { data: appUsers, refetch, isLoading } = useAppUsers()

  const users = useMemo(() => appUsers ?? [], [appUsers])

  const rows = useMemo(
    () =>
      users.filter((user) =>
        includesLowerCase(`${user.firstName} ${user.lastName} ${user.email}`, search),
      ),
    [users, search],
  )

  const handleDelete = useDeleteSelectedUsers(users, selected, showToast, () => {
    setSelected([])
    return refetch()
  })

  return (
    <UsersPageLayout
      activeTab="app"
      actions={<AppUsersHeaderActions selected={selected} handleDelete={handleDelete} />}
    >
      <Toast />
      <UsersSearchGrid
        search={search}
        onSearchChange={setSearch}
        columns={appUsersColumns}
        rows={rows}
        loading={isLoading}
        onRowSelectionModelChange={setSelected}
      />
    </UsersPageLayout>
  )
}
